import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import './AdminDashboard.css';
import { GiFilmSpool } from "react-icons/gi";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    navigate('/admin/login');
  };

  return (
    <AdminLayout>
      <div className="admin-dashboard">
        <div className="dashboard-header">
          <h1>Impact Stories Fund Dashboard</h1>
          <p>Welcome back!</p>
        </div>
        
        <div className="dashboard-grid">
          <div className="dashboard-card">
            <div className="card-icon"><GiFilmSpool/></div>
            <h3>Film Management</h3>
            <p>Upload, edit, and manage films</p>
            <Link to="/films" className="card-link">
              Manage Films →
            </Link>
          </div>
          
          {/* <div className="dashboard-card">
            <div className="card-icon">📊</div>
            <h3>Analytics</h3>
            <p>View site statistics and reports</p>
            <span className="card-coming-soon">Coming Soon</span>
          </div> */}
          
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;